import { CustomerService, AuthenticationError } from '../../services/customer-service'
import TokenService from '../../services/token-service'
import { PushNotificationService } from '../../services/push-notification-service'

const state =  {
    authenticating: false,
    accessToken: TokenService.getToken(),
    authenticationSuccess: false,
    loggedIn: false,
    authenticationErrorCode: 0,
    authenticationError: '',
    refreshTokenPromise: null,  // Holds the promise of the refresh token
    maintenanceMode: false
}

const getters = {
    loggedIn: (state) => {
        //return state.loggedIn
        return state.accessToken ? true : false
    },

    authenticationErrorCode: (state) => {
        return state.authenticationErrorCode
    },

    authenticationError(state){
        return state.authenticationError
    },

    authenticationSuccess(state){
        return state.authenticationSuccess
    },

    authenticating: (state) => {
        return state.authenticating
    },

    maintenanceMode: (state) => {
        return state.maintenanceMode
    },
}

const actions = {
    async login({ commit },{userId, password}) {
        commit('loginRequest');
        try {

            if(password != ""){
                const result = await CustomerService.login(userId, password);
            
                if(result.status == "4000"){
                    commit('loginSuccess')
                }
                return result
            }
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }
            return false
        }
    },

    async validateLoginOtp({ commit },{email, password}) {
        
        try {
            //console.log("email: "+email, "password: "+password);
            const token = await CustomerService.validateLoginOtp(email, password);
            //console.log("token : ", token);
            commit('loggedIn', token.data.result.access_token)
            //TokenService.saveToken(token.data.result.access_token);
           
            return token
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }
            return false
        }
    },

    logout({ commit }) {
        CustomerService.logout()
        PushNotificationService.logoutDevice();
        commit('logoutSuccess')
        // router.push('/login')
    },

    /* eslint-disable */
    async refreshToken({ commit }) {
        
        try {
            const token = await CustomerService.refreshToken();
            commit('loggedIn', token.data.result.access_token)

            return token
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }
            return false
        }
    
    },

    async refreshExpiredToken({ commit },{password}) {
        
        try {
            const token = await CustomerService.refreshExpiredToken(password);
            commit('loggedIn', token.data.result.access_token)

            return token
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }
            return false
        }
        
    },

    async resetpassword({ commit }, {newpassword, confirmpassword}) {
        
        try {
           
            const result = await CustomerService.resetpassword(newpassword, confirmpassword);
            
            if(result != false){
                commit('loggedIn', result.data.access_token)

            }
           
            return result
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }
            return false
        }
    },

    resetLoginState({ commit }) {
        commit('resetLoginState')
    },
    
    setMaintenanceMode({ commit }, mode) {
        commit('setMaintenance', mode)
    },
    /* eslint-enable */
}

const mutations = {
    loginRequest(state) {
        state.authenticating = true;
        state.authenticationError = ''
        state.authenticationErrorCode = 0
        state.authenticationSuccess = false;
        state.loggedIn = false;
    },

    loginSuccess(state) {
        state.authenticationSuccess = true;
        state.authenticating = false;
        state.loggedIn = false;
    },

    loggedIn(state, accessToken) {
        state.accessToken = accessToken;
        state.authenticationSuccess = true;
        state.authenticating = false;
        state.loggedIn = true;
    },

    loginError(state, {errorCode, errorMessage}) {
        state.authenticating = false
        state.authenticationErrorCode = errorCode
        state.authenticationError = errorMessage
        state.authenticationSuccess = false;
        state.loggedIn = false;

    },

    logoutSuccess(state) {
        state.accessToken = ''
        state.authenticationSuccess = false;
        state.loggedIn = false;
        
    },

    refreshTokenPromise(state, promise) {
        state.refreshTokenPromise = promise
    },

    resetLoginState(state) {
        state.authenticating = false;
        state.authenticationSuccess = false;
        state.loggedIn = false;
        state.authenticationError = ''
        state.authenticationErrorCode = 0
    },

    setMaintenance(state, value) {
        state.maintenanceMode = value;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}